<template>
  <ul
    class="sidebar-menu"
    v-if="authService.currentRole.nama_role === 'Jasa Antar'"
  >
    <router-link
      to="/jasa-antar"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="fas fa-home" /><span>Home</span></a>
    </router-link>
    <li class="menu-header">
      Pesanan
    </li>
    <router-link
      to="/pesanan"
      tag="li"
    >
      <a
        class="nav-link"
        href="javasript.void(0)"
      ><i class="far fa-list-alt" /><span>Pesanan</span></a>
    </router-link>
  </ul>
</template>

<script>
export default {
	data() {
		return {

		}
	},
	computed: {
		authService(){
			return this.$store.getters.getAuthService
		}
	},
	created(){

	}
}
</script>